import { useEffect, useState } from "react";
import {
  fetchLocationStates,
  fetchLocationCities,
  fetchLocationZips
} from "../services/locationOptionsService";

export const useLocationOptions = (state: string, city: string) => {
  const [states, setStates] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [zips, setZips] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const result = await fetchLocationStates();
        if (!cancelled) {
          setStates(result);
        }
      } catch {
        if (!cancelled) {
          setStates([]);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const normalizedState = state.trim();
    if (!normalizedState) {
      setCities([]);
      setZips([]);
      return;
    }

    let cancelled = false;
    void (async () => {
      try {
        const result = await fetchLocationCities(normalizedState);
        if (!cancelled) {
          setCities(result);
        }
      } catch {
        if (!cancelled) {
          setCities([]);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [state]);

  useEffect(() => {
    const normalizedState = state.trim();
    const normalizedCity = city.trim();
    if (!normalizedState || !normalizedCity) {
      setZips([]);
      return;
    }

    let cancelled = false;
    void (async () => {
      try {
        const result = await fetchLocationZips(normalizedState, normalizedCity);
        if (!cancelled) {
          setZips(result);
        }
      } catch {
        if (!cancelled) {
          setZips([]);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [state, city]);

  return { states, cities, zips };
};
